<template>
  <v-card v-if="loading" min-height="400px" >
    <v-card-text class="d-flex align-center justify-center">
      <Loader label="Загрузка конфигурации GSA" />
    </v-card-text>
  </v-card>
  <v-card v-else>
    <v-card-title>
      Удаленная конифгурация GSA
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <DestinationParams :config="config.destination" />
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="green"
        :loading="saving"
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
        Сохранить

      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Loader from './ui/Loader.vue'
import DestinationParams from './DestinationParams.vue'

export default {
  props: ['agent_guid'],
  data: () => ({
    saving: false,
    loading: true,
    config: {}
  }),
  methods: {
    async save(){
      this.saving = true
      try {
        await this.$store.dispatch('update_gsa_config', {agent_guid: this.agent_guid, payload: {destination: this.config.destination} })
        this.$emit('greet')
      } catch (e) {
        console.error(e)
      }
      this.saving = false
    }
  },
  async mounted(){
    try {
      this.config = await this.$store.dispatch('get_gsa_config', this.agent_guid)
    } catch (e) {
      this.$emit('close')
    }
    this.loading = false
  },
  components:{
    Loader,
    DestinationParams
  }
}
</script>